import moment from "moment-timezone";


const UtcDateTimeToDateTime = (UtcDateTime, String) => {
    const timestamp = parseInt(UtcDateTime !== undefined ? UtcDateTime["$date"]["$numberLong"] : String);
    const dateObj = moment.tz(timestamp, 'Europe/Madrid');
    return dateObj.format('YYYY-MM-DD HH:mm:ss.SSSSS');
}

const GetDateTimeLocal = (DateTime) => {
    const date = DateTime ? DateTime : new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Agrega un 0 inicial si es necesario
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export {UtcDateTimeToDateTime, GetDateTimeLocal}